export default __webpack_public_path__ + "static/media/Welcome.63ba6472.md";